import { Box, Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { useCallback } from "react";

const WhatsAppIcon = ({ sx, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ width: sx?.fontSize || 24, height: sx?.fontSize || 24, ...sx }}
    {...props}
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const WhatsAppContact = () => {
  const phoneNumber = "08505324994";
  // WhatsApp URL formatı: ülke kodu (90) + numara - baştaki 0 ve tüm boşluklar kaldırılır
  // Türkiye numaraları için: 08505324994 -> 0 kaldır -> 8505324994 -> 90 ekle -> 908505324994
  // Ancak bu numara 11 haneli, mobil numaralar 10 hane olmalı (05XX XXX XX XX)
  // Eğer numara 0505324994 formatında olsaydı: 90 + 505324994 = 90505324994
  // Şu anki numara formatına göre işleme:
  let cleanNumber = phoneNumber.replace(/\s/g, "").replace(/^0/, ""); // Boşlukları ve baştaki 0'ı kaldır
  const whatsappNumber = "90" + cleanNumber; // Başına 90 ekle
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  const handleWhatsAppClick = useCallback(() => {
    // WhatsApp Web veya mobil uygulamayı aç
    window.open(whatsappUrl, "_blank");
  }, [whatsappUrl]);


  return (
    <Box className="support-request">
      <h6>
        <PhoneIcon /> WhatsApp ile Destek
      </h6>
      <Box className="whatsapp-contact-wrapper">
        <Box className="whatsapp-contact-content">
          <Box className="whatsapp-icon-container">
            <WhatsAppIcon sx={{ fontSize: 80, color: "#25D366", mr: 0 }} />
          </Box>
          <Box className="whatsapp-info">
            <p className="whatsapp-description">
              Destek ekibimizle WhatsApp üzerinden hızlıca iletişime geçebilirsiniz.
              Aşağıdaki numaraya tıklayarak WhatsApp üzerinden mesaj gönderebilirsiniz.
            </p>
            <Box 
              className="whatsapp-phone-number"
              onClick={handleWhatsAppClick}
            >
              <WhatsAppIcon sx={{ fontSize: 24, color: "#25D366", mr: 1 }} />
              <span className="phone-number-text">{phoneNumber}</span>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="support-request-done">
        <Button 
          onClick={handleWhatsAppClick}
          sx={{ 
            backgroundColor: "#25D366 !important",
            "&:hover": {
              backgroundColor: "#128C7E !important",
            }
          }}
        >
          <WhatsAppIcon sx={{ mr: 1, fontSize: 20 }} />
          WhatsApp ile Bağlan
        </Button>
      </Box>
    </Box>
  );
};

export default WhatsAppContact;

